import PasswordChange from "./password-change";

export default PasswordChange;
